import { SyncState } from '../enums';

export const SyncStates = [
  SyncState.CONNECTED,
  SyncState.DISCONNECTED,
  SyncState.VALID,
  SyncState.WARNING,
  SyncState.ALERT,
  SyncState.ERROR,
];
